// type ThemeAll = Theme & ReturnType<typeof createTheme> & ReturnType<typeof useTheme>;
import { AppTheme } from ".";

export class ThemeHelper {
  static getTabsBorderColor<T extends AppTheme>(theme: T): string {
    const defaultColor = theme.palette.divider;
    const indicatorColor = theme.components?.MuiTabs?.defaultProps?.indicatorColor;
    return indicatorColor ? theme.palette[indicatorColor]?.main || defaultColor : defaultColor;
  }
}
